// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
    padding: 0;
    margin: 0;
    scroll-behavior: thin;
}
img {
    max-width: 100%;
}
#root a:not(.nav-link) {
    color: inherit;
    text-decoration: none;
}

* {
    margin: 0;
    padding: 0;
    text-rendering: optimizeLegibility;
    text-rendering: optimizeSpeed;
    box-sizing: border-box;
    font-family: var(--primary-font) !important;
}

#root ul:not(.side-menu-bar) {
    padding: 0px;
    margin: 0px;
}
#root ul li {
    list-style: none;
}
h1,
h2,
h3,
h4,
h5,
h6 {
    line-height: 1.2;
}
p {
    margin-bottom: 0px;
}
/* color root */

:root {
    --primary-font: 'proxima-nova';
    --white-10: #f8f8ff;
    --white: #fff;
    --indigo-100: #e0e7ff;
    --indigo-200: #c7d2fe;
    --indigo-500: #6366f1;
    --indigo-400: #818cf8;
    --indigo-600: #4f46e5;
    --indigo-800: #3730a3;
    --indigo-900: #312e81;
    --indigo-25: #f4f7ff;
    --indigo-50: #eef2ff;
    --purpel-graident: linear-gradient(99deg, #8993f9 3.58%, #4555ee 92.14%);
    --cool-grey-800: #1f2937;
    --cool-grey-700: #374151;
    --cool-grey-200: #e5e7eb;
    --cool-grey-500: #6b7280;
    --cool-grey-600: #4b5563;
    --cool-grey-400: #9ca3af;
    --cool-grey-100: #f3f4f6;
    --cool-grey-300: #d1d5db;
    --cool-grey-50: #f9fafb;
    --red-400: #f87171;
    --green-400: #34d399;
    --green-100: #dcfce7;
    --green-600: #16a34a;
    --yellow-10: #fbbf24;
    --yellow-100: #fef9c3;
    --yellow-300: #fcd34d;
    --yellow-500: #eab308;
    --blue-gray-50: #f8fafc;
    --blue-500: #3b82f6;
    --blue-100: #dbeafe;
}

/* font */

/* scrollbar */
*::-webkit-scrollbar {
    width: 5px;
    border-radius: 10px;
    height: 5px;
}
*::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
}
*::-webkit-scrollbar-thumb {
    background: var(--cool-grey-300);
    border-radius: 10px;
}

@media (prefers-reduced-motion: no-preference) {
    .App-logo {
        animation: App-logo-spin infinite 20s linear;
    }
}

.App-header {
    background-color: #282c34;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: calc(10px + 2vmin);
    color: white;
}

.App-link {
    color: #61dafb;
}
.Toastify__toast-container .Toastify__toast {
    border-radius: 30px;
    background-color: var(--cool-grey-800);
    padding: 6px 20px;
    min-height: 48px;
}
.Toastify__toast-container .Toastify__toast .Toastify__toast-body {
    padding: 0px;
    margin: 0px;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.1;
    order: 2;
}
.Toastify__toast-container .Toastify__toast .Toastify__close-button {
    order: 1;
    line-height: 1;
    margin-right: 16px;
    color: #dde546;
    position: relative;
    top: 8px;
}

.draft-link .project-card-bottom {
    padding-bottom: 16px;
    visibility: hidden;
    opacity: 0;
    height: 0px;
    transition: all 300ms ease-in-out;
}

.draft-link:hover .project-card-bottom {
    visibility: visible;
    opacity: 1;
    height: auto;
    transition: all 300ms ease-in-out;
}

.project-popup-content.project-email {
    word-break: break-all;
}

/* .css-1p3m7a8-multiValue {
  background-color: transparent !important;
}

.css-wsp0cs-MultiValueGeneric {
  padding: 0 !important;
  padding-left: 0px !important;
  padding-right: 5px !important;
  font-size: 14px !important;
}

.css-12a83d4-MultiValueRemove {
  display: none !important;
} */

/* loader css */

.loader-main {
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    height: 100%;
    background: rgba(255, 255, 255, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
}

.spin-loader {
    animation-name: loaderspin;
    animation-duration: 1000ms;
    animation-iteration-count: infinite;
    animation-timing-function: linear;

    -webkit-animation-name: loaderspin;
    -webkit-animation-duration: 1000ms;
    -webkit-animation-iteration-count: infinite;
    -webkit-animation-timing-function: linear;

    -moz-animation-name: loaderspin;
    -moz-animation-duration: 1000ms;
    -moz-animation-iteration-count: infinite;
    -moz-animation-timing-function: linear;

    -ms-animation-name: loaderspin;
    -ms-animation-duration: 1000ms;
    -ms-animation-iteration-count: infinite;
    -ms-animation-timing-function: linear;
}
@keyframes loaderspin {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}

@keyframes App-logo-spin {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}

.spinner-card.card-structure {
    overflow: hidden;
    min-height: calc(100vh - 120px);
}
.no-claims-table {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    min-height: 180px;
}
.no-claims-table .icon-box {
    display: inline-block;
}
.loader-inner {
    line-height: 1;
}
/* map css */
.gmnoprint.gm-bundled-control .gmnoprint > div {
    width: 32px !important;
}
.gmnoprint.gm-bundled-control .gmnoprint > div > div {
    width: 22px !important;
}
.gmnoprint > div {
    height: initial !important;
    border-radius: 30px !important;
    box-shadow: 0px 5px 8px 0px rgba(89, 89, 115, 0.12);
}
.gmnoprint .gm-control-active {
    width: 32px !important;
    height: 32px !important;
}
.gmnoprint .gm-control-active img {
    width: 12px !important;
    height: 12px !important;
}

.search-property-main .main-div {
    height: 700px;
}
.search-property-main .card-structure {
    position: relative;
}
.custom-result {
    display: flex;
    align-items: center;
}
.custom-result .searchClass {
    flex: 1 1;
}
.custom-result .result-count {
    padding-left: 12px;
    font-size: 14px;
    font-weight: 400;
    color: var(--cool-grey-800);
}
.property-map-modal .map-image-frame {
    height: calc(100vh - 160px);
}
.edit-project-map .main-div {
    height: 650px;
}
.gm-style .gm-style-iw-c {
    box-shadow: 0px 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
    border: 1px solid var(--cool-grey-200) !important;
    border-radius: 16px;
    padding: 16px !important;
    top: -40px;
}
.gm-style .gm-style-iw-tc::after {
    top: -41px;
}

.gm-style .gm-style-iw-c .property-map-structure {
    border-radius: 0px;
    border: none;
    padding: 0px;
    box-shadow: none;
}
.gm-style .gm-style-iw-c .property-id-card:after {
    display: none;
}
.gm-style .gm-style-iw-c .gm-style-iw-d {
    max-height: auto !important;
    overflow: hidden !important;
}
.gm-style .gm-style-iw-c button.gm-ui-hover-effect {
    width: 10px;
    height: 10px;
}
.gm-style-iw-ch {
    padding-top: 12px;
}
/* popup styles */
.gm-style .gm-style-iw-t div[role="dialog"] {
    max-width: 350px !important;
}
.form-check.select-check {
    margin-bottom: 4px;
}
.form-check.select-check .form-check-input {
    width: 18px;
    height: 18px;
}
.custom-select-box.select-borderless {
    max-width: 110px;
}


/* Pdf css */
.pdf-inner-file-section .custom-thumbnail-item {
    background-color: transparent !important;
    border-radius: 4px;
}
.pdf-inner-file-section .rpv-thumbnail__container {
    box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.06), 0px 4px 6px -1px rgba(0, 0, 0, 0.1) !important;
}
.pdf-inner-file-section .custom-thumbnail-item {
    padding: 10px 10px 0 10px;
    margin-bottom: 10px;
}
.pdf-inner-file-section .custom-thumbnail-item.active-page {
    border: 1px solid var(--indigo-600) !important;
}
.pdf-inner-file-section .active-label {
    color: var(--indigo-600);
}
.pdf-loader {
    height: calc(100vh - 210px);
}
.pdf-loader .loader-main {
    z-index: 9;
}
.text-trunk {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 150px;
}
.chips-scroll {
    max-height: 150px;
    overflow-y: auto;
}
.explorer-regulation-outer {
    padding-right: 1px;
}

.create-project-body .main-div {
    min-height: 600px;
}

/* map button  */
#custom-toggle-boundaries-control {
    position: absolute;
    bottom: 215px;
    right: 17px;
    background: #fff;
    box-shadow: 0px 5px 8px 0px rgba(89, 89, 115, 0.12);
    z-index: 1;
    border-radius: 50%;
    cursor: pointer;
}

#custom-map-control {
    position: absolute;
    bottom: 125px;
    right: 17px;
    background: #fff;
    box-shadow: 0px 5px 8px 0px rgba(89, 89, 115, 0.12);
    z-index: 1;
    border-radius: 50%;
    cursor: pointer;
}

.switch-container {
    display: flex;
    flex: 1 1;
    flex-direction: row;
    justify-content: space-between;
    gap: 10px;
}

#custom-fullscreen-control {
    position: absolute;
    bottom: 170px;
    right: 17px;
    background: #fff;
    box-shadow: 0px 5px 8px 0px rgba(89, 89, 115, 0.12);
    z-index: 1;
    border-radius: 50%;
    cursor: pointer;
}

#custom-enable-layer-button {
    position: absolute;
    bottom: 300px;
    right: 17px;
    background: #fff;
    box-shadow: 0px 5px 8px 0px rgba(89, 89, 115, 0.12);
    z-index: 1;
    border-radius: 50%;
    cursor: pointer;
}

.area-category-container {
    display: flex;
    flex-direction: row;
    gap: 10px;
}

.show-hide-lyaer-map-container {
    margin-top: 10px;
    margin-bottom: 10px;
}

.low-income-layer-legend-container {
    margin-bottom: 10px;
}

.categories-text {
    font-weight: 500;
    font-size: 15px;
}

.low-income-category-1-layer-legend-element {
    background-color:#e38aeb; /* 66eb8ae3 */
    height: 20px;
    width: 20px;
}

.energy-community-coal-closure-layer-legend-element {
    background-color: #7FD748; /* 6648D77F  */
    opacity: 0.7;
    height: 20px;
    width: 20px;
}

.energy-community-msa-nmsa-layer-legend-element {
    background-color: #5a9a33; /* 66339A5A */
    opacity: 0.7;
    height: 20px;
    width: 20px;
}

.low-income-cejst-legend-element {
    background-color: #EE6495; /* 669564EE */
    opacity: 0.7;
    height: 20px;
    width: 20px;
}

.low-income-ppc-legend-element {
    background-color: #833E9A; /* 669A3E83 */
    opacity: 0.7;
    height: 20px;
    width: 20px;
}

.solar-zoning-largeScale-legend-element {
    background-color: #fff200; /* 6600F2FF */
    opacity: 0.7;
    height: 20px;
    width: 20px;
}

.solar-zoning-mediumScale-legend-element {
    background-color: #9d9d9d; /* 669d9d9d */
    opacity: 0.7;
    height: 20px;
    width: 20px;
}

.toogle-container {
    margin-top: 10px;
    margin-left: 20px;
}

.toogle-line-container {
    display: flex;
    gap: 10px;
}

.map-type-dropdown {
    position: absolute;
    width: 220px;
    right: -17px;
    background-color: #fff;
    border: 1px solid #e5e7eb;
    padding: 20px;
    border-radius: 16px 0 12px 0;
    transform: scale(0);
    transform-origin: bottom right;
    opacity: 0;
    backface-visibility: hidden;
    transition: all 300ms ease-in-out;
    -webkit-transition: all 300ms ease-in-out;
    -moz-transition: all 300ms ease-in-out;
    /* min-height: 180px;45 */
}
.map-type-dropdown.dropdown-active {
    visibility: visible;
    opacity: 1;
    transform: scale(1);
}

.main-div {
    /* position: relative; */
    border-radius: 12px;
    overflow: hidden;
}

[aria-label='Toggle fullscreen view'] {
    top: auto !important;
    bottom: 170px !important;
    width: 32px !important;
    height: 32px !important;
    border-radius: 50% !important;
    box-shadow: 0px 5px 8px 0px rgba(89, 89, 115, 0.12) !important;
    right: 17px !important;
    margin: 0px 0 15px 0 !important;
}
[aria-label='Toggle fullscreen view'] img {
    width: 17px !important;
    height: 17px !important;
    border-radius: 4px !important;
}

.show-alert .dropdown-toggle::before {
    content: '';
    position: absolute;
    top: 3px;
    right: 9px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: var(--indigo-600);
    border: 1px solid #fff;
}
.projects.side-menu-bar {
    max-height: 200px;
    overflow-y: auto;
}

@media only screen and (max-height: 1199px) {
    .side-menu-bar .cstm-btn {
        padding: 6px 8px;
    }
}

@media only screen and (max-height: 400px) {
    .property-map-modal .map-image-frame {
        height: 280px;
    }
    .file-modal .pdf-center-file {
        max-height: 200px;
    }
}

@media only screen and (max-width: 850px) {
    .create-project-main .footer-project .cstm-btn {
        font-size: 15px;
        padding: 6px 12px;
        min-width: 100px;
    }
    .create-project-main .footer-project .cstm-link-btn-icon {
        font-size: 15px;
    }
    .create-project-main .footer-project .cstm-btn .icon-sm.pr4 {
        padding-right: 4px;
    }
    .create-project-main .footer-project.gap-3 {
        gap: 4px !important;
    }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;IAEI,UAAU;IACV,SAAS;IACT,qBAAqB;AACzB;AACA;IACI,eAAe;AACnB;AACA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,kCAAkC;IAClC,6BAA6B;IAC7B,sBAAsB;IACtB,2CAA2C;AAC/C;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;AACA;IACI,gBAAgB;AACpB;AACA;;;;;;IAMI,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;AACA,eAAe;;AAEf;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,oBAAoB;IACpB,oBAAoB;IACpB,wEAAwE;IACxE,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IACxB,uBAAuB;IACvB,kBAAkB;IAClB,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;IACpB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA,SAAS;;AAET,cAAc;AACd;IACI,UAAU;IACV,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI;QACI,4CAA4C;IAChD;AACJ;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,sCAAsC;IACtC,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,QAAQ;AACZ;AACA;IACI,QAAQ;IACR,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;;;;;;;;;;;;;GAaG;;AAEH,eAAe;;AAEf;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;IAC1B,0BAA0B;IAC1B,mCAAmC;IACnC,iCAAiC;;IAEjC,kCAAkC;IAClC,kCAAkC;IAClC,2CAA2C;IAC3C,yCAAyC;;IAEzC,+BAA+B;IAC/B,+BAA+B;IAC/B,wCAAwC;IACxC,sCAAsC;;IAEtC,8BAA8B;IAC9B,8BAA8B;IAC9B,uCAAuC;IACvC,qCAAqC;AACzC;AAyBA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,gBAAgB;IAChB,+BAA+B;AACnC;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,cAAc;AAClB;AACA,YAAY;AACZ;IACI,sBAAsB;AAC1B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,0BAA0B;IAC1B,8BAA8B;IAC9B,mDAAmD;AACvD;AACA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;AACA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,SAAO;AACX;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,2BAA2B;AAC/B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,aAAa;AACjB;AACA;IACI,8DAA8D;IAC9D,iDAAiD;IACjD,mBAAmB;IACnB,wBAAwB;IACxB,UAAU;AACd;AACA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,aAAa;AACjB;AACA;IACI,2BAA2B;IAC3B,2BAA2B;AAC/B;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,iBAAiB;AACrB;AACA,iBAAiB;AACjB;IACI,2BAA2B;AAC/B;AACA;IACI,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,gBAAgB;AACpB;;;AAGA,YAAY;AACZ;IACI,wCAAwC;IACxC,kBAAkB;AACtB;AACA;IACI,gGAAgG;AACpG;AACA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;AACA;IACI,8CAA8C;AAClD;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,UAAU;AACd;AACA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;AACpB;AACA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA,gBAAgB;AAChB;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,mDAAmD;IACnD,UAAU;IACV,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,mDAAmD;IACnD,UAAU;IACV,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAO;IACP,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,mDAAmD;IACnD,UAAU;IACV,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,mDAAmD;IACnD,UAAU;IACV,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,wBAAwB,EAAE,aAAa;IACvC,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,yBAAyB,EAAE,cAAc;IACzC,YAAY;IACZ,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,yBAAyB,EAAE,aAAa;IACxC,YAAY;IACZ,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,yBAAyB,EAAE,aAAa;IACxC,YAAY;IACZ,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,yBAAyB,EAAE,aAAa;IACxC,YAAY;IACZ,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,yBAAyB,EAAE,aAAa;IACxC,YAAY;IACZ,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,yBAAyB,EAAE,aAAa;IACxC,YAAY;IACZ,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,yBAAyB;IACzB,aAAa;IACb,4BAA4B;IAC5B,mBAAmB;IACnB,8BAA8B;IAC9B,UAAU;IACV,2BAA2B;IAC3B,iCAAiC;IACjC,yCAAyC;IACzC,sCAAsC;IACtC,yBAAyB;AAC7B;AACA;IACI,mBAAmB;IACnB,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,wBAAwB;IACxB,sBAAsB;IACtB,uBAAuB;IACvB,6BAA6B;IAC7B,8DAA8D;IAC9D,sBAAsB;IACtB,+BAA+B;AACnC;AACA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mCAAmC;IACnC,sBAAsB;AAC1B;AACA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;IACA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;QACjB,gBAAgB;IACpB;IACA;QACI,eAAe;IACnB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,mBAAmB;IACvB;AACJ","sourcesContent":["html,\nbody {\n    padding: 0;\n    margin: 0;\n    scroll-behavior: thin;\n}\nimg {\n    max-width: 100%;\n}\n#root a:not(.nav-link) {\n    color: inherit;\n    text-decoration: none;\n}\n\n* {\n    margin: 0;\n    padding: 0;\n    text-rendering: optimizeLegibility;\n    text-rendering: optimizeSpeed;\n    box-sizing: border-box;\n    font-family: var(--primary-font) !important;\n}\n\n#root ul:not(.side-menu-bar) {\n    padding: 0px;\n    margin: 0px;\n}\n#root ul li {\n    list-style: none;\n}\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n    line-height: 1.2;\n}\np {\n    margin-bottom: 0px;\n}\n/* color root */\n\n:root {\n    --primary-font: 'proxima-nova';\n    --white-10: #f8f8ff;\n    --white: #fff;\n    --indigo-100: #e0e7ff;\n    --indigo-200: #c7d2fe;\n    --indigo-500: #6366f1;\n    --indigo-400: #818cf8;\n    --indigo-600: #4f46e5;\n    --indigo-800: #3730a3;\n    --indigo-900: #312e81;\n    --indigo-25: #f4f7ff;\n    --indigo-50: #eef2ff;\n    --purpel-graident: linear-gradient(99deg, #8993f9 3.58%, #4555ee 92.14%);\n    --cool-grey-800: #1f2937;\n    --cool-grey-700: #374151;\n    --cool-grey-200: #e5e7eb;\n    --cool-grey-500: #6b7280;\n    --cool-grey-600: #4b5563;\n    --cool-grey-400: #9ca3af;\n    --cool-grey-100: #f3f4f6;\n    --cool-grey-300: #d1d5db;\n    --cool-grey-50: #f9fafb;\n    --red-400: #f87171;\n    --green-400: #34d399;\n    --green-100: #dcfce7;\n    --green-600: #16a34a;\n    --yellow-10: #fbbf24;\n    --yellow-100: #fef9c3;\n    --yellow-300: #fcd34d;\n    --yellow-500: #eab308;\n    --blue-gray-50: #f8fafc;\n    --blue-500: #3b82f6;\n    --blue-100: #dbeafe;\n}\n\n/* font */\n\n/* scrollbar */\n*::-webkit-scrollbar {\n    width: 5px;\n    border-radius: 10px;\n    height: 5px;\n}\n*::-webkit-scrollbar-track {\n    background: #f1f1f1;\n    border-radius: 10px;\n}\n*::-webkit-scrollbar-thumb {\n    background: var(--cool-grey-300);\n    border-radius: 10px;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n    .App-logo {\n        animation: App-logo-spin infinite 20s linear;\n    }\n}\n\n.App-header {\n    background-color: #282c34;\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    font-size: calc(10px + 2vmin);\n    color: white;\n}\n\n.App-link {\n    color: #61dafb;\n}\n.Toastify__toast-container .Toastify__toast {\n    border-radius: 30px;\n    background-color: var(--cool-grey-800);\n    padding: 6px 20px;\n    min-height: 48px;\n}\n.Toastify__toast-container .Toastify__toast .Toastify__toast-body {\n    padding: 0px;\n    margin: 0px;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 1.1;\n    order: 2;\n}\n.Toastify__toast-container .Toastify__toast .Toastify__close-button {\n    order: 1;\n    line-height: 1;\n    margin-right: 16px;\n    color: #dde546;\n    position: relative;\n    top: 8px;\n}\n\n.draft-link .project-card-bottom {\n    padding-bottom: 16px;\n    visibility: hidden;\n    opacity: 0;\n    height: 0px;\n    transition: all 300ms ease-in-out;\n}\n\n.draft-link:hover .project-card-bottom {\n    visibility: visible;\n    opacity: 1;\n    height: auto;\n    transition: all 300ms ease-in-out;\n}\n\n.project-popup-content.project-email {\n    word-break: break-all;\n}\n\n/* .css-1p3m7a8-multiValue {\n  background-color: transparent !important;\n}\n\n.css-wsp0cs-MultiValueGeneric {\n  padding: 0 !important;\n  padding-left: 0px !important;\n  padding-right: 5px !important;\n  font-size: 14px !important;\n}\n\n.css-12a83d4-MultiValueRemove {\n  display: none !important;\n} */\n\n/* loader css */\n\n.loader-main {\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    right: 0px;\n    bottom: 0px;\n    height: 100%;\n    background: rgba(255, 255, 255, 0.8);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.spin-loader {\n    animation-name: loaderspin;\n    animation-duration: 1000ms;\n    animation-iteration-count: infinite;\n    animation-timing-function: linear;\n\n    -webkit-animation-name: loaderspin;\n    -webkit-animation-duration: 1000ms;\n    -webkit-animation-iteration-count: infinite;\n    -webkit-animation-timing-function: linear;\n\n    -moz-animation-name: loaderspin;\n    -moz-animation-duration: 1000ms;\n    -moz-animation-iteration-count: infinite;\n    -moz-animation-timing-function: linear;\n\n    -ms-animation-name: loaderspin;\n    -ms-animation-duration: 1000ms;\n    -ms-animation-iteration-count: infinite;\n    -ms-animation-timing-function: linear;\n}\n@-moz-keyframes loaderspin {\n    from {\n        transform: rotate(0deg);\n    }\n    to {\n        transform: rotate(360deg);\n    }\n}\n@-ms-keyframes loaderspin {\n    from {\n        transform: rotate(0deg);\n    }\n    to {\n        transform: rotate(360deg);\n    }\n}\n@-webkit-keyframes loaderspin {\n    from {\n        transform: rotate(0deg);\n    }\n    to {\n        transform: rotate(360deg);\n    }\n}\n@keyframes loaderspin {\n    from {\n        transform: rotate(0deg);\n    }\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n@keyframes App-logo-spin {\n    from {\n        transform: rotate(0deg);\n    }\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n.spinner-card.card-structure {\n    overflow: hidden;\n    min-height: calc(100vh - 120px);\n}\n.no-claims-table {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    min-height: 180px;\n}\n.no-claims-table .icon-box {\n    display: inline-block;\n}\n.loader-inner {\n    line-height: 1;\n}\n/* map css */\n.gmnoprint.gm-bundled-control .gmnoprint > div {\n    width: 32px !important;\n}\n.gmnoprint.gm-bundled-control .gmnoprint > div > div {\n    width: 22px !important;\n}\n.gmnoprint > div {\n    height: initial !important;\n    border-radius: 30px !important;\n    box-shadow: 0px 5px 8px 0px rgba(89, 89, 115, 0.12);\n}\n.gmnoprint .gm-control-active {\n    width: 32px !important;\n    height: 32px !important;\n}\n.gmnoprint .gm-control-active img {\n    width: 12px !important;\n    height: 12px !important;\n}\n\n.search-property-main .main-div {\n    height: 700px;\n}\n.search-property-main .card-structure {\n    position: relative;\n}\n.custom-result {\n    display: flex;\n    align-items: center;\n}\n.custom-result .searchClass {\n    flex: 1;\n}\n.custom-result .result-count {\n    padding-left: 12px;\n    font-size: 14px;\n    font-weight: 400;\n    color: var(--cool-grey-800);\n}\n.property-map-modal .map-image-frame {\n    height: calc(100vh - 160px);\n}\n.edit-project-map .main-div {\n    height: 650px;\n}\n.gm-style .gm-style-iw-c {\n    box-shadow: 0px 25px 50px -12px rgba(0, 0, 0, 0.25) !important;\n    border: 1px solid var(--cool-grey-200) !important;\n    border-radius: 16px;\n    padding: 16px !important;\n    top: -40px;\n}\n.gm-style .gm-style-iw-tc::after {\n    top: -41px;\n}\n\n.gm-style .gm-style-iw-c .property-map-structure {\n    border-radius: 0px;\n    border: none;\n    padding: 0px;\n    box-shadow: none;\n}\n.gm-style .gm-style-iw-c .property-id-card:after {\n    display: none;\n}\n.gm-style .gm-style-iw-c .gm-style-iw-d {\n    max-height: auto !important;\n    overflow: hidden !important;\n}\n.gm-style .gm-style-iw-c button.gm-ui-hover-effect {\n    width: 10px;\n    height: 10px;\n}\n.gm-style-iw-ch {\n    padding-top: 12px;\n}\n/* popup styles */\n.gm-style .gm-style-iw-t div[role=\"dialog\"] {\n    max-width: 350px !important;\n}\n.form-check.select-check {\n    margin-bottom: 4px;\n}\n.form-check.select-check .form-check-input {\n    width: 18px;\n    height: 18px;\n}\n.custom-select-box.select-borderless {\n    max-width: 110px;\n}\n\n\n/* Pdf css */\n.pdf-inner-file-section .custom-thumbnail-item {\n    background-color: transparent !important;\n    border-radius: 4px;\n}\n.pdf-inner-file-section .rpv-thumbnail__container {\n    box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.06), 0px 4px 6px -1px rgba(0, 0, 0, 0.1) !important;\n}\n.pdf-inner-file-section .custom-thumbnail-item {\n    padding: 10px 10px 0 10px;\n    margin-bottom: 10px;\n}\n.pdf-inner-file-section .custom-thumbnail-item.active-page {\n    border: 1px solid var(--indigo-600) !important;\n}\n.pdf-inner-file-section .active-label {\n    color: var(--indigo-600);\n}\n.pdf-loader {\n    height: calc(100vh - 210px);\n}\n.pdf-loader .loader-main {\n    z-index: 9;\n}\n.text-trunk {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 150px;\n}\n.chips-scroll {\n    max-height: 150px;\n    overflow-y: auto;\n}\n.explorer-regulation-outer {\n    padding-right: 1px;\n}\n\n.create-project-body .main-div {\n    min-height: 600px;\n}\n\n/* map button  */\n#custom-toggle-boundaries-control {\n    position: absolute;\n    bottom: 215px;\n    right: 17px;\n    background: #fff;\n    box-shadow: 0px 5px 8px 0px rgba(89, 89, 115, 0.12);\n    z-index: 1;\n    border-radius: 50%;\n    cursor: pointer;\n}\n\n#custom-map-control {\n    position: absolute;\n    bottom: 125px;\n    right: 17px;\n    background: #fff;\n    box-shadow: 0px 5px 8px 0px rgba(89, 89, 115, 0.12);\n    z-index: 1;\n    border-radius: 50%;\n    cursor: pointer;\n}\n\n.switch-container {\n    display: flex;\n    flex: 1;\n    flex-direction: row;\n    justify-content: space-between;\n    gap: 10px;\n}\n\n#custom-fullscreen-control {\n    position: absolute;\n    bottom: 170px;\n    right: 17px;\n    background: #fff;\n    box-shadow: 0px 5px 8px 0px rgba(89, 89, 115, 0.12);\n    z-index: 1;\n    border-radius: 50%;\n    cursor: pointer;\n}\n\n#custom-enable-layer-button {\n    position: absolute;\n    bottom: 300px;\n    right: 17px;\n    background: #fff;\n    box-shadow: 0px 5px 8px 0px rgba(89, 89, 115, 0.12);\n    z-index: 1;\n    border-radius: 50%;\n    cursor: pointer;\n}\n\n.area-category-container {\n    display: flex;\n    flex-direction: row;\n    gap: 10px;\n}\n\n.show-hide-lyaer-map-container {\n    margin-top: 10px;\n    margin-bottom: 10px;\n}\n\n.low-income-layer-legend-container {\n    margin-bottom: 10px;\n}\n\n.categories-text {\n    font-weight: 500;\n    font-size: 15px;\n}\n\n.low-income-category-1-layer-legend-element {\n    background-color:#e38aeb; /* 66eb8ae3 */\n    height: 20px;\n    width: 20px;\n}\n\n.energy-community-coal-closure-layer-legend-element {\n    background-color: #7FD748; /* 6648D77F  */\n    opacity: 0.7;\n    height: 20px;\n    width: 20px;\n}\n\n.energy-community-msa-nmsa-layer-legend-element {\n    background-color: #5a9a33; /* 66339A5A */\n    opacity: 0.7;\n    height: 20px;\n    width: 20px;\n}\n\n.low-income-cejst-legend-element {\n    background-color: #EE6495; /* 669564EE */\n    opacity: 0.7;\n    height: 20px;\n    width: 20px;\n}\n\n.low-income-ppc-legend-element {\n    background-color: #833E9A; /* 669A3E83 */\n    opacity: 0.7;\n    height: 20px;\n    width: 20px;\n}\n\n.solar-zoning-largeScale-legend-element {\n    background-color: #fff200; /* 6600F2FF */\n    opacity: 0.7;\n    height: 20px;\n    width: 20px;\n}\n\n.solar-zoning-mediumScale-legend-element {\n    background-color: #9d9d9d; /* 669d9d9d */\n    opacity: 0.7;\n    height: 20px;\n    width: 20px;\n}\n\n.toogle-container {\n    margin-top: 10px;\n    margin-left: 20px;\n}\n\n.toogle-line-container {\n    display: flex;\n    gap: 10px;\n}\n\n.map-type-dropdown {\n    position: absolute;\n    width: 220px;\n    right: -17px;\n    background-color: #fff;\n    border: 1px solid #e5e7eb;\n    padding: 20px;\n    border-radius: 16px 0 12px 0;\n    transform: scale(0);\n    transform-origin: bottom right;\n    opacity: 0;\n    backface-visibility: hidden;\n    transition: all 300ms ease-in-out;\n    -webkit-transition: all 300ms ease-in-out;\n    -moz-transition: all 300ms ease-in-out;\n    /* min-height: 180px;45 */\n}\n.map-type-dropdown.dropdown-active {\n    visibility: visible;\n    opacity: 1;\n    transform: scale(1);\n}\n\n.main-div {\n    /* position: relative; */\n    border-radius: 12px;\n    overflow: hidden;\n}\n\n[aria-label='Toggle fullscreen view'] {\n    top: auto !important;\n    bottom: 170px !important;\n    width: 32px !important;\n    height: 32px !important;\n    border-radius: 50% !important;\n    box-shadow: 0px 5px 8px 0px rgba(89, 89, 115, 0.12) !important;\n    right: 17px !important;\n    margin: 0px 0 15px 0 !important;\n}\n[aria-label='Toggle fullscreen view'] img {\n    width: 17px !important;\n    height: 17px !important;\n    border-radius: 4px !important;\n}\n\n.show-alert .dropdown-toggle::before {\n    content: '';\n    position: absolute;\n    top: 3px;\n    right: 9px;\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    background-color: var(--indigo-600);\n    border: 1px solid #fff;\n}\n.projects.side-menu-bar {\n    max-height: 200px;\n    overflow-y: auto;\n}\n\n@media only screen and (max-height: 1199px) {\n    .side-menu-bar .cstm-btn {\n        padding: 6px 8px;\n    }\n}\n\n@media only screen and (max-height: 400px) {\n    .property-map-modal .map-image-frame {\n        height: 280px;\n    }\n    .file-modal .pdf-center-file {\n        max-height: 200px;\n    }\n}\n\n@media only screen and (max-width: 850px) {\n    .create-project-main .footer-project .cstm-btn {\n        font-size: 15px;\n        padding: 6px 12px;\n        min-width: 100px;\n    }\n    .create-project-main .footer-project .cstm-link-btn-icon {\n        font-size: 15px;\n    }\n    .create-project-main .footer-project .cstm-btn .icon-sm.pr4 {\n        padding-right: 4px;\n    }\n    .create-project-main .footer-project.gap-3 {\n        gap: 4px !important;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
